import { defineStore } from "pinia";
import { useAuthStore } from "./auth.store";

// Definicja store Pinia do zarządzania filtrami VMS
export const useVmsFilterStore = defineStore({
  id: "vmsFilter",
  state: () => ({
    filters: {},        // przechowuje aktualnie wybrane filtry
    locations: [],      // stacje preselekcji, które mają przypisaną grupę znaków
    authStore: useAuthStore(), // odwołanie do autoryzacji (do obsługi błędów)
  }),
  getters: {
    // Getter zwracający cały obiekt filtrów
    items: (state) => state.filters,

    // Getter zwracający wybrane lokalizacje jako obiekty (po id)
    selectedLocation: (state) => {
      if (state.filters.locations) {
        // Zwróć tylko te lokalizacje, których id są w filtrach
        return state.locations.filter((location) => {
          return state.filters.locations.includes(location.id);
        });
      }
      return [];
    },
  },
  actions: {
    /**
     * Ustawia listę stacji na podstawie grup znaków pobranych ze store'u VMS.
     *
     * Lista celowo NIE pochodzi z endpointu ze wszystkimi lokalizacjami systemu - w panelu mają się pojawić
     * wyłącznie te stacje, które faktycznie mają grupę znaków. Pozostałe i tak nie miałyby czego odfiltrować.
     *
     * @param {Object} groupLocations Mapa: id grupy -> stacja preselekcji.
     */
    setLocationsFromGroups(groupLocations = {}) {
      const unique = new Map();

      Object.values(groupLocations).forEach((location) => {
        if (location?.id) {
          unique.set(location.id, location);
        }
      });

      this.locations = [...unique.values()].sort((a, b) =>
        (a.shortName || "").localeCompare(b.shortName || "")
      );

      // Stacja mogła zniknąć z listy (np. grupa została wyłączona) - wtedy filtr przestaje mieć sens.
      if (this.filters.locations?.some((id) => !unique.has(id))) {
        delete this.filters.locations;
      }
    },

    /**
     * Dodaje (lub ustawia) filtr. Specjalna obsługa dla lokalizacji - tylko jedna zaznaczona naraz.
     * @param {string} name - nazwa filtra (np. 'LocationList', 'status', 'type')
     * @param {any} value - wartość filtra
     */
    addItem(name, value) {
      switch (name) {
        case "LocationList": {
          if (this.filters.locations) {
            if (!this.filters.locations.includes(value)) {
              // Jeżeli nie było tej lokalizacji - ustaw ją
              this.filters.locations = [value];
            } else {
              // Jeżeli już była wybrana - usuń ją (odznaczenie)
              this.filters.locations = [];
            }
          } else {
            this.filters.locations = [value];
          }
          // Jeśli nic nie zostało - usuń property z obiektu filtrów
          if (this.filters.locations.length == 0) {
            delete this.filters.locations;
          }
          break;
        }
        default: {
          // Dla innych filtrów - ustaw po prostu wartość
          this.filters[name] = value;
        }
      }
    },

    /**
     * Usuwa dany filtr z obiektu filtrów
     * @param {string} name - nazwa filtra
     */
    removeItem(name) {
      switch (name) {
        default: {
          delete this.filters[name];
        }
      }
    },

    /**
     * Ustawia globalny komunikat błędu (np. do wyświetlenia w UI)
     */
    setErrors(error) {
      this.authStore.errorMessage = error;
    },
  },
});

// Hot Module Reloading dla Pinia Store podczas developmentu (nie wpływa na produkcję)
// if (typeof import.meta !== 'undefined' && import.meta.hot) {
//   import.meta.hot.accept(acceptHMRUpdate(useVmsFilterStore, import.meta.hot));
// }
